import { render, staticRenderFns } from "./FaqsForm.vue?vue&type=template&id=204b9fb0"
import script from "./FaqsForm.vue?vue&type=script&lang=js"
export * from "./FaqsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports